import { Address } from '@root/types';

export default (address: Address): string => {
  return `${address.city}, ${address.abbreviatedRegion}`;
};
